import { Observable } from "rxjs";

export class Filter {
  key: string = '';
  value?: string | null = null;
  matchType: number = 0;
  dataType?: number = 0;
}

export class Criteria {
  groupLogicalOperator: number = 0;
  filters: Filter[] = [];
}

export class SortBy {
  sortBy: string = '';
  sortDirection: number = 0; //0: Descending, 1: Ascending
}

export class SearchModel {
  criteria: Criteria[] = [];
  queryColumn: string = '';
  logicalOperatorBetweenGroups: number = 0;
  searchValue: string = '';
  sortBy: SortBy[] = [];
  pageNumber?: number | null = 1;
  pageSize?: number | null = 10;
  exportColumns?: string[];
}

export interface ExportConfig {
  api: (model: SearchModel) => Observable<any>;
  searchModel: SearchModel;
  title: string;
  extraParam?: string[];
  excludeParam?: string[];
  overrideParam?: Record<string, string[]>;
}